import { ReactComponent as HomeIcon } from 'assets/Icons/Home.svg'
import { ReactComponent as IncentivesIcon } from 'assets/Icons/Tag.svg'
import { ReactComponent as ReportsIcon } from 'assets/Icons/Pie-Chart.svg'
import { ReactComponent as SettingsIcon } from 'assets/Icons/Settings.svg'
import { ReactComponent as TeamIcon } from 'assets/Icons/Team.svg'
import { MdReceipt } from 'react-icons/md'
import { SideNavItemProps } from 'components/SideNavItem'
import { RouteMap } from 'lib/router'
import { lazy } from 'react'
import ReportsContainer from 'containers/ReportsContainer'
import AuditLogContainer from '../containers/AuditLogContainer'

const CompaniesHomeContainer = lazy(
  () => import('containers/CompaniesHomeContainer')
)
const IncentiveContainer = lazy(() => import('containers/IncentiveContainer'))
const IncentivesContainer = lazy(() => import('containers/IncentivesContainer'))
const BillingContainer = lazy(() => import('containers/BillingContainer'))
const GroupOrdersContainer = lazy(
  () => import('containers/GroupOrdersContainer')
)
const HelpContainer = lazy(() => import('containers/HelpContainer'))
const ConnectionsContainer = lazy(
  () => import('containers/ConnectionsContainer')
)
const ProfileContainer = lazy(() => import('containers/ProfileContainer'))
const TeamContainer = lazy(() => import('containers/TeamContainer'))
const EmployeesContainer = lazy(() => import('containers/EmployeesContainer'))
const MemberCampaignContainer = lazy(
  () => import('containers/MemberCampaignContainer')
)
const MemberCampaignsContainer = lazy(
  () => import('containers/MemberCampaignsContainer')
)
const NotFound = lazy(() => import('views/NotFound'))
const CompanySettings = lazy(() => import('views/Settings/CompanySettings'))

export const companyRoutes: RouteMap<SideNavItemProps> = [
  {
    path: '/',
    exact: true,
    component: CompaniesHomeContainer,
    navTitle: 'pmportal.nav.home',
    navIcon: HomeIcon,
  },
  {
    path: '/workspaces/:workspaceId/employees',
    component: EmployeesContainer,
    navTitle: 'pmportal.nav.employees',
    navIcon: TeamIcon,
  },
  {
    path: '/workspaces/:workspaceId/incentives/:incentivePlanId',
    component: IncentiveContainer,
    navTitle: 'pmportal.nav.incentives',
  },
  {
    path: '/workspaces/:workspaceId/incentives',
    component: IncentivesContainer,
    navTitle: 'pmportal.nav.incentives',
    navIcon: IncentivesIcon,
    featureFlag: 'hera_incentive_plans',
  },
  {
    path: '/workspaces/:workspaceId/group-orders',
    component: GroupOrdersContainer,
    navTitle: 'pmportal.nav.groupOrders',
    navIcon: MdReceipt,
    breadcrumb: 'pmportal.nav.groupOrders',
    featureFlag: 'hera_group_orders_page_enabled',
  },
  {
    path: '/workspaces/:workspaceId/reports',
    component: ReportsContainer,
    navTitle: 'pmportal.nav.reports',
    navIcon: ReportsIcon,
    featureFlag: 'hera_workspace_reports_enabled',
  },
  {
    path: '/workspaces/:workspaceId/settings/help',
    component: HelpContainer,
    breadcrumb: 'pmportal.nav.help',
  },
  {
    path: '/workspaces/:workspaceId/settings/billing',
    component: BillingContainer,
    breadcrumb: 'pmportal.nav.billing',
  },
  {
    path: '/workspaces/:workspaceId/settings/history',
    render: () => <AuditLogContainer />,
    breadcrumb: 'pmportal.nav.history',
  },
  {
    path: '/workspaces/:workspaceId/settings/team',
    component: TeamContainer,
    breadcrumb: 'pmportal.nav.team',
  },
  {
    path: '/workspaces/:workspaceId/settings/profile',
    component: ProfileContainer,
    breadcrumb: 'pmportal.nav.myProfile',
  },
  {
    path: '/workspaces/:workspaceId/settings/connections',
    component: ConnectionsContainer,
    breadcrumb: 'pmportal.nav.connections',
  },
  {
    path: '/workspaces/:workspaceId/settings/member-campaigns/:campaignId',
    component: MemberCampaignContainer,
    breadcrumb: 'pmportal.nav.memberCampaign',
  },
  {
    path: '/workspaces/:workspaceId/settings/member-campaigns',
    component: MemberCampaignsContainer,
    breadcrumb: 'pmportal.nav.memberCampaigns',
  },
  {
    path: '/workspaces/:workspaceId/settings',
    component: CompanySettings,
    navTitle: 'pmportal.nav.settings',
    navIcon: SettingsIcon,
    breadcrumb: 'pmportal.nav.settings',
  },
  {
    path: '*',
    component: NotFound,
  },
]
